var scope_0 = require('/github/workspace/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c22991aee20ab88fb25c8e6684452219.js').default;
var scope_1 = require('/github/workspace/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    